<script>
	import Multiselect from "vue-multiselect";
	import { mapState, mapGetters } from "vuex";
  import {store} from "@/store/store";
  import i18n from "@/i18n";

	export default {
		components: {
			Multiselect
		},
		data() {
			return {
				openMenu: false,
				name: "",
				select_money_enabled: false
			};
		},
		computed: {
			...mapState({
				is_superadmin: state => state.home.is_superadmin,
				printableLangs: state => state.langs.printableLangs.sort((a,b) => { return a.name.localeCompare(b.name); }),
        config: state => state.settings.config
			}),
      ...mapGetters(['computedPrintableLang', 'hasAccessToCurrencies', 'previousLang']),
			printableLang: {
				get() {
					return this.computedPrintableLang;
				},
				set(value) {
          this.$store.commit('setPreviousPrintableLang', this.computedPrintableLang);
					this.$store.commit("setPrintableLang", value);
          this.$store.commit("updateHeadersByLang", this.previousLang);
          // update mentions by lang first settled by router
          if (this.config.accounting?.delay?.rate?.std) {
            this.$store.commit("penalityPercentage", this.config.accounting.delay.translations[value.key].rate.std);
          }
          if (this.config.accounting?.delay?.rate) {
            this.$store.commit("penalityTextTemplate", this.config.accounting.delay.translations[value.key].rate.text);
          }

          if (this.config.accounting?.delay?.compensation?.std) {
            this.$store.commit("penalityAmount", this.config.accounting.delay.translations[value.key].compensation.std);
          }
          if (this.config.accounting?.delay?.compensation) {
            this.$store.commit("indemnityTextTemplate", this.config.accounting.delay.translations[value.key].compensation.text);
          }

          if (this.config.accounting?.delay?.payment) {
            this.$store.commit("paymentTextDaysTemplate", this.config.accounting.delay.translations[value.key].payment["text-days"]);
            this.$store.commit("paymentTextNowTemplate", this.config.accounting.delay.translations[value.key].payment["text-now"]);
          }

          this.$store.commit('updateNumbersByLang', this.previousLang);

        }

			}
		},
		methods: {
			redirectToSubscriptionSelect () {
				top.window.location.href = `${this.app_path.url}settings/subscription/select/`;
			},
		}
	};
</script>

<template>
	<div>
		<Multiselect
			v-if="hasAccessToCurrencies || is_superadmin"
			v-model="printableLang"
			:options="printableLangs"
			label="name"
			track-by="key"
			:show-labels="false"
			:option-height="104"
			class="floating-model-menu"
			:multiple="false"
			:placeholder="$t('Nom de la langue')"
		>
			<!-- Options on the select -->
			<template slot="option" slot-scope="props">
				<div class="option__desc">
					<span class="option__title"> {{ $t(props.option.name) }} </span>
				</div>
			</template>

			<template slot="singleLabel" slot-scope="props">
				<span class="option__desc">
					<span class="option__title"> {{ $t(props.option.name) }} </span>
				</span>
			</template>

			<template #noOptions>
				{{ $t("La liste est vide.") }}
			</template>

			<template slot="noOptions">
				{{ $t("La liste est vide.") }}
			</template>
		</Multiselect>

		<div v-else>
			{{ $t("Passez sur un le plan") }}
			<b-button variant="light" size="sm" @click="redirectToSubscriptionSelect"> {{ $t("Standard") }} <b-icon-star-fill font-scale="1.2" /> </b-button>
			{{ $t("ou") }} 
			<b-button variant="light" size="sm" @click="redirectToSubscriptionSelect"> {{ $t("Standard") }} <b-icon-star-fill font-scale="1.2" /> </b-button>
			{{ $t("pour pouvoir utiliser cette fonctionnalité et facturer dans l’une de ces langues !") }}
			<div class="currencies_info">
				<ul style="width: 100%; padding-left: 1rem; list-style-type: none">
					<li 
						v-for="lang in printableLangs" 
						:key="lang.code"
					>
						- {{ $t(lang.name) }}
					</li>
				</ul>
			</div>
		</div>

		<!--div style="padding-top: 15px; color:rgb(170, 170, 170)" v-html="$t('language_menu_description')" / -->
	</div>
</template>

<style lang="scss">
	.floating-model-menu {
		.option {
			&__title {
				align-items: center;
				display: flex;
			}

			&__desc {
				width: 100%;
				display: flex;
				justify-content: space-between;
			}

			&__trash.b-icon {
				font-size: 20px;
			}
		}

		.multiselect__option {
			padding: 10 px;
		}
	}
</style>
